export default function TotalIcon() {
  return (
    <svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.4141 8.72656L14.2814 8.5939C13.5004 7.81285 12.234 7.81285 11.453 8.5939L9.9668 10.0801C9.43285 10.614 8.56715 10.614 8.0332 10.0801V10.0801C7.49926 9.54613 6.63356 9.54613 6.09961 10.0801L2.8125 13.3672M2.8125 3.3125V13.3672M15.1875 15.6875H4.8125C3.70793 15.6875 2.8125 14.7921 2.8125 13.6875V13.3672'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
